import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Popup from '../Popup';

const DiscardModal = ({
  title,
  isOpened,
  onSubmit,
  submitText,
  cancelText,
  onCancel,
  intl: { formatMessage },
}) => (
  <Popup
    strictClose
    opened={isOpened}
    width="xsmall"
    mobileFullScreen={false}
    customControls
    onSubmit={onSubmit}
    submitText={submitText || formatMessage({ id: 'common.remove' })}
    submitBtnColor="danger"
    onClose={onCancel}
    cancelText={cancelText || formatMessage({ id: 'common.cancel' })}
    enabled
    withHeading={false}
  >
    <p className="fw6 f-16 g-color--primary mt3">{title}</p>
  </Popup>
);

DiscardModal.propTypes = {
  title: PropTypes.string,
  isOpened: PropTypes.bool,
  onSubmit: PropTypes.func,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default injectIntl(DiscardModal);



// WEBPACK FOOTER //
// ./src/components/common/DiscardModal/index.jsx